<template>
  <div class="order rebateCash">
    <head-panel
      title="财务管理"
      subtitle="FINANCIAL MANAGEMENT"
      :exportUrl="activeName === '2' ? financial.rebateDown : ''"
    ></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">返货管理</h3>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="is-simple">
        <el-tab-pane label="人工返货" name="1"></el-tab-pane>
        <el-tab-pane label="返货记录明细" name="2"></el-tab-pane>
      </el-tabs>
      <ny-date-range @change="dateChange" class="el-date-editor" :shortcut="true" v-model="date"></ny-date-range>
      <div class="selectBox clearfix">
        <ny-select
          :data="financial.rebateTypeMenu"
          v-model="financial.curRebateType"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          type="userType"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <!-- <ny-select
          :data="financial.editUserMenu"
          v-model="financial.curEditUser"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          type="userMenu"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>-->
        <el-input class="searchBox" icon="search" v-model="adverId" placeholder="请输入广告主ID"></el-input>
        <el-input class="searchBox" icon="search" v-model="accountName" placeholder="请输入账号名称"></el-input>

        <el-input class="searchBox" icon="search" v-model="adverName" placeholder="请输入广告主名称"></el-input>
        <el-button class="oprSuccess mr55" @click="searchData">搜索</el-button>
      </div>
      <div class="adTable">
        <ny-table
          class="tableBox mt20"
          :page="financial.rebatePage"
          :pageFalse="true"
          @size-change="changePageSize"
          @current-change="changePageSize"
          v-loading="loading"
        >
          <template slot v-if="financial.rebatePage.data.length>0 && activeName === '1'">
            <el-table-column fixed="right" label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="handlePrice(scope.$index, scope.row, 'add')"
                  type="primary"
                  size="small"
                  class="comButton ssButton"
                >加返货</el-button>
                <el-button
                  @click="handlePrice(scope.$index, scope.row, 'minus')"
                  type="primary"
                  size="small"
                  class="comButton ssButton is-refund"
                >退返货</el-button>
              </template>
            </el-table-column>
          </template>
        </ny-table>
      </div>
    </div>
    <custom-dialog :customDialog="premiumDialog" class="priceCus">
      <!-- 加款-->
      <div slot="dialogCon">
        <priceCus
          :rowId="rowId"
          :money="money"
          :type="addPrice"
          :platform="platform"
          :data="addMenu"
          @surePrice="surePrice"
          @cancelPrice="cancelPrice"
          :errorShow="errorShow.add"
          :committing="committing"
        ></priceCus>
      </div>
    </custom-dialog>
    <custom-dialog :customDialog="refundDialog" class="priceCus">
      <!-- 退款-->
      <div slot="dialogCon">
        <priceCus
          :rowId="rowId"
          :type="refund"
          :money="money"
          :data="refundMenu"
          :platform="platform"
          @surePrice="surePrice"
          @cancelPrice="cancelPrice"
          :errorShow="errorShow.refund"
          :committing="committing"
          :setMax="setMax"
        ></priceCus>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import { headPanel, NySelect, NyTable, customDialog, priceCus, NyDateRange } from '@/global/components';
import { mapGetters } from 'vuex';
import { post } from '@/manager/http/index'
export default {
  name: 'advertiser',
  data () {
    return {
      adver: {
        value: ''
      },
      money: {
        addCash: '',
        addGoods: '',
        cash: '',
        goods: '',
        type: 1
      },
      rowId: '',
      platform: '',
      downloadExc: '',
      adverName: '',
      accountName: '',
      adverId: '',
      setMax: '',
      date: [],
      startTime: '',
      endTime: '',
      addMenu: [
      ],
      refundMenu: [
      ],
      addPrice: {
        title: '加返货金额',
        type: 'add',
        cashType: 2
      },
      refund: {
        title: '退返货金额',
        type: 'refund',
        cashType: 2
      },
      errorShow: {
        add: false,
        refund: false
      },
      activeName: '1',
      loading: false,
      premiumDialog: {// 加款
        visible: false,
        isClickModal: false
      },
      refundDialog: {// 退款
        visible: false,
        isClickModal: false
      },
      committing: false // 提交状态
    };
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.platform = this.$router.currentRoute.meta.platform
      await this.getRebateTypeMenu()
      // await this.getUserMenu({ value: this.financial.curEditType })
      this.getRebateInfo()
    },
    async getRebateTypeMenu () {
      let api = this.activeName === '1' ? 'rebate_select' : 'rebate_log_select'
      await this.$store.dispatch('finance/getRebateTypeMenu', { type: api })
    },
    getRebateInfo ({ currentPage, pageSize, startTime, endTime } = {}) {
      this.$store.dispatch('finance/getRebateData', {
        userType: this.financial.curRebateType,
        currentPage,
        pageSize,
        accountName: this.accountName,
        userId: this.adverId,
        userName: this.adverName,
        activeName: this.activeName,
        startTime: this.startTime,
        endTime: this.endTime
      })
    },
    changeSelect ({ value, type }) {
    },
    changePageSize ({ currentPage, pageSize } = {}) {
      this.getRebateInfo({ currentPage, pageSize })
    },
    searchData () {
      this.financial.rebatePage.resetData()
      this.getRebateInfo()
    },
    async handleClick () {
      this.financial.rebatePage.resetData()
      await this.getRebateTypeMenu()
      this.getRebateInfo()
    },
    disDate (time) {
      return new Date(time) > Date.now();
    },
    dateChange (date) {
      this.startTime = date[0]
      this.endTime = date[1]
      this.getRebateInfo({ startTime: date[0], endTime: date[1] })
    },
    handlePrice (index, row, handleType) {
      this.rowId = row;
      if (handleType === 'add') {
        this.premiumDialog.visible = true;
      } else {
        this.refundDialog.visible = true;
      }
      post('/admin/finance/balance', {
        user_type: this.rowId.balance_type,
        account_id: this.rowId.id
      }).then(res => {
        if (res.code === 1) {
          // this.money.cash = res.data.data.cash_balance
          this.money.goods = res.data.data.rebate_balance
          if (handleType !== 'add') {
            this.setMax = res.data.data.rebate_balance
          }
        }
      })
    },
    surePrice ({ handleType, form }) {
      this.committing = true
      let data = {}
      let self = this
      let api = '/admin/finance/balance'
      data.account_id = this.rowId.id
      data.user_type = this.rowId.balance_type
      if (handleType === 'add') {
        self.submitMoney({ handleType, form })
      } else {
        post(api, data).then(res => {
          if (res.code === 1) {
            let balance = res.data.data.rebate_balance
            if (balance >= parseInt(form.price) || handleType === 'add') {
              self.errorShow.add = false
              self.submitMoney({ handleType, form })
            } else {
              self.errorShow.add = true
            }
          }
        })
      }
    },
    submitMoney ({ handleType, form }) {
      let self = this
      let params = {}
      params.user_id = self.rowId.id
      params.p_id = self.userid
      params.money = form.price
      params.ext = form.remark
      params.user_type = self.rowId.money_type
      params.balance_type = 2
      params.name = self.rowId.name
      params.type = handleType === 'add' ? 1 : 2
      params.account_id = self.userid
      post('/admin/finance/money', params).then(res => {
        self.committing = false
        if (res.code === 1) {
          if (handleType === 'add') {
            self.premiumDialog.visible = false;
            self.$message('加款成功')
          } else {
            self.refundDialog.visible = false;
            self.$message('退款成功')
          }
          self.getRebateInfo()
        } else {
          self.$message(res.msg)
        }
      }).catch(() => {
        self.committing = false
      })
    },
    cancelPrice ({ handleType }) {
      if (handleType === 'add') {
        this.premiumDialog.visible = false;
      } else {
        this.refundDialog.visible = false;
      }
    },
    handleRebate (index, row) {
      this.$router.push({ name: 'rebateFinancial', params: { id: row.id } })
    }
  },
  components: {
    headPanel,
    NySelect,
    NyTable,
    customDialog,
    priceCus,
    NyDateRange
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.rebateCash {
  .ml20 {
    margin-left: 20px;
  }
  .el-date-editor {
    margin-left: 20px;
    margin-top: 20px;
  }
  .el-tabs.is-simple {
    .el-tabs__item {
      width: 180px;
      text-align: center;
    }
  }
  .add_order {
    width: 114px;
    b {
      float: left;
      font-size: 20px;
      font-weight: 600;
      margin-top: 0px;
    }
  }
  .el-date-editor {
    margin-right: 20px;
  }
  .selectBox {
    margin-top: 20px;
    .el-select {
      width: 230px;
    }
  }
  .priceCus {
    .el-dialog {
      width: 500px;
    }
  }
}
</style>
